/* eslint-disable internal-rules/no-hardcoded-colors */
import { BuildingBlockLayouts, BuildingBlock } from '@pendo/services/BuildingBlocks';
import { getContent } from '@/guides/helpers/common.util.js';
import { buildResourceCenterBadge } from '@/utils/resource-center-helper.js';
import sharedServices from '@pendo/services/package.json';

function createBadge (resourceCenter, badgeSrcUrl) {
    const badgeBuildingBlocks = BuildingBlockLayouts.createBaseBuildingBlocksForLayout(
        'badgeResourceCenter',
        resourceCenter.id,
        { src: badgeSrcUrl },
    );
    const badgeDom = BuildingBlock.buildingBlocksToDom(badgeBuildingBlocks);

    resourceCenter.attributes.badge = {
        bbJson: badgeBuildingBlocks,
        color: '#FF4876',
        domJson: badgeDom,
        isOnlyShowOnce: false,
        name: 'pendo-chevron',
        position: 'inline',
        showBadgeOnlyOnElementHover: false,
        showGuideOnBadgeHover: false,
    };
}

function createResourceCenterAttribute (resourceCenter) {
    const { moduleIds } = BuildingBlockLayouts;

    resourceCenter.attributes.resourceCenter = {
        children: [],
        isTopLevel: true,
        moduleId: moduleIds.homeView,
        originId: resourceCenter.id,
    };
}

function createNotificationBubble (resourceCenter) {
    resourceCenter.attributes.notificationBubble = {
        'background-color': '#EC2059',
        'font-weight': 400,
        'font-family': 'inherit',
        'color': '#FFFFFF',
    };
}

function createBuildingBlocksAndDom (resourceCenter) {
    const { moduleIds, createResourceCenterBuildingBlocksForLayout } = BuildingBlockLayouts;

    const resourceCenterBuildingBlocks = createResourceCenterBuildingBlocksForLayout(
        moduleIds.homeView,
        resourceCenter.steps[0].id,
        { resourceCenterTitle: resourceCenter.name },
    );

    resourceCenter.steps[0].buildingBlocks = JSON.stringify(resourceCenterBuildingBlocks);
    resourceCenter.steps[0].dom = JSON.stringify(BuildingBlock.buildingBlocksToDom(resourceCenterBuildingBlocks));
}

export async function createDraftResourceCenter ({ resourceCenter, activeAppId }) {
    const badgeSrc = await buildResourceCenterBadge();
    resourceCenter.attributes.sharedServiceVersion = sharedServices.version;
    createBadge(resourceCenter, badgeSrc);
    createResourceCenterAttribute(resourceCenter);
    createNotificationBubble(resourceCenter);

    resourceCenter.appId = activeAppId;
    resourceCenter.name = 'Resource Center';
    resourceCenter.launchMethod = 'badge';
    // check if steps[0] is always defined when createGuide returns
    resourceCenter.steps[0].elementPathRule = 'body';

    createBuildingBlocksAndDom(resourceCenter);

    return getContent(resourceCenter);
}
